'use strict';

const FORM_SAVE_RESULT = module.exports = {
  SAVED: 'SAVED',
  NO_CHANGES: 'NO_CHANGES',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  ERROR_SAVING: 'ERROR_SAVING',
};



// WEBPACK FOOTER //
// ./src/js/forms/FORM_SAVE_RESULT.js